export const getAccountNumber = loanData => {
  const accountNumber = `${
    loanData.institution_account_number || loanData.bafs_account_number || ""
  }`;
  return accountNumber ? ` | ${accountNumber}` : "";
};

export default getAccountNumber;
